import { Link } from "react-router-dom";
import Logo from "../../assets/images/log.png";
import "./header.scss";
import { useState, useEffect } from "react"

const Header = () => {
    const location = window.location.pathname;
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const userToken = localStorage.getItem('accessToken');
        if (userToken) {
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
    }, []);

    // Body scroll ni bloklash
    useEffect(() => {
        if (mobileMenuOpen) {
            document.body.classList.add('menu-open');
        } else {
            document.body.classList.remove('menu-open');
        }

        // Cleanup
        return () => {
            document.body.classList.remove('menu-open');
        };
    }, [mobileMenuOpen]);

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        setIsAuthenticated(false);
        setMobileMenuOpen(false);
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    return (
        <div className="header">
            <div className="container">
                <div className="logo">
                    <Link to="/" onClick={closeMobileMenu}>
                        <img src={Logo} alt="Logo" />
                    </Link>
                </div>

                {/* Mobile Menu Button */}
                <button 
                    className={`mobile-menu-btn ${mobileMenuOpen ? 'active' : ''}`}
                    onClick={toggleMobileMenu}
                    aria-label="Menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                {/* Navigation Links */}
                <div className={`links ${mobileMenuOpen ? 'open' : ''}`} style={{width:'100%'}}>
                    <div className="pages">
                        <Link
                            className={location === "/" ? "active" : ""}
                            to="/"
                            onClick={closeMobileMenu}
                        >
                            Bosh sahifa
                        </Link>
                        <Link
                            className={location === "/videos" ? "active" : ""}
                            to="/videos"
                            onClick={closeMobileMenu}
                        >
                            Kurslar
                        </Link>
                    </div>

                    <div className="logini">
                        {!isAuthenticated && (
                            <Link to="/login" onClick={closeMobileMenu}>
                                Kirish
                            </Link>
                        )}
                        
                        {isAuthenticated ? (
                            <Link 
                                className="signup" 
                                to="/" 
                                onClick={handleLogout}
                            >
                                Chiqish
                            </Link>
                        ) : (
                            <Link 
                                className="signup" 
                                to="/signup"
                                onClick={closeMobileMenu}
                            >
                                Ro'yxatdan o'tish
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            
            {/* Mask */}
            {mobileMenuOpen && <div className="maska" onClick={closeMobileMenu}></div>}
        </div>
    );
};

export default Header;